// extracted by mini-css-extract-plugin
export var lg = "_4j-4";
export var md = "_4j-3";
export var sm = "_4j-2";
export var xs = "_4j-1";
export var xxs = "_4j-0";